module.exports = __webpack_public_path__ + "img/Mask Group 2938@2x.c755d556.png";